import { useState } from 'react';
import { getCpk } from '../../../shared/services/spc/getCpk.ts';
import { SpcOverrides, SpcOverridesMap, SpcResultsPos } from '../../../shared/types/spc.ts';
import { getToleranceRangeStrings } from '../../../shared/utils/getToleranceRange.ts';
import { SpcOverridesDialog } from './spcOverridesDialog.tsx';


interface Props {
    style?: React.CSSProperties
    spcResult: SpcResultsPos
    overrides: SpcOverridesMap
    setOverrides: (positionNumber: string, overrides: SpcOverrides | null) => void
}

export function PositionDetails({
    style,
    spcResult,
    overrides,
    setOverrides,
}: Props) {

    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const position = spcResult.position;
    const controlValues = spcResult.controlValues;
    const currentOverrides = overrides[position.positionNumber];

    const toleranceRange = getToleranceRangeStrings(position);
    const cpk = getCpk(controlValues);
    const numMeasurements = spcResult.measurements
        .map(it => it.recordPosition.value)
        .filter(it => it !== '' && it != null)
        .length;


    return (
        <div className='flex--vert-centered'>
            <table style={style}>
                <tbody>
                    <tr>
                        <td>Nominal</td>
                        <td>{position.nominal}</td>
                    </tr>
                    <tr>
                        <td>Mean</td>
                        <td>{controlValues?.mean.toFixed(3)}</td>
                    </tr>
                    <tr>
                        <td>Stddev</td>
                        <td>{controlValues?.stddev.toFixed(3)}</td>
                    </tr>
                    <tr>
                        <td>Sigma 1</td>
                        <td>{controlValues && `${controlValues.sigma1[0].toFixed(3)} / ${controlValues.sigma1[1].toFixed(3)}`}</td>
                    </tr>
                    <tr>
                        <td>Sigma 2</td>
                        <td>{controlValues && `${controlValues.sigma2[0].toFixed(3)} / ${controlValues.sigma2[1].toFixed(3)}`}</td>
                    </tr>
                    <tr>
                        <td>Sigma 3</td>
                        <td>{controlValues && `${controlValues.sigma3[0].toFixed(3)} / ${controlValues.sigma3[1].toFixed(3)}`}</td>
                    </tr>
                    <tr>
                        <td>Upper tolerance</td>
                        <td>{position.upperTolerance} &rarr; {toleranceRange.max}</td>
                    </tr>
                    <tr>
                        <td>Lower tolerance</td>
                        <td>{position.lowerTolerance} &rarr; {toleranceRange.min}</td>
                    </tr>
                    <tr>
                        <td>Cpk</td>
                        <td style={{ backgroundColor: (cpk != null && cpk < 1 ? '#ffdebb' : undefined) }}>
                            {cpk != null && cpk.toFixed(3)}
                        </td>
                    </tr>
                    <tr>
                        <td>Measurements</td>
                        <td>{numMeasurements}</td>
                    </tr>
                </tbody>
            </table>

            {!currentOverrides &&
                <div>
                    <span
                        className='a__button'
                        onClick={() => setIsDialogOpen(true)}
                        children={'Override values'}
                    />
                </div>
            }
            {currentOverrides &&
                <div>
                    <span
                        className='a__button'
                        style={{ color: '#f00' }}
                        onClick={() => setIsDialogOpen(true)}
                        children={'Overrides'}
                    />
                    <span
                        style={{ color: '#f00' }}
                        children={' applied. '}
                    />
                    <span
                        className='a__button'
                        style={{ color: '#f00' }}
                        onClick={() => setOverrides(position.positionNumber, null)}
                        children={'Clear'}
                    />
                </div>
            }

            {isDialogOpen && <SpcOverridesDialog
                overrides={currentOverrides}
                setOverrides={(overrides) => setOverrides(position.positionNumber, overrides)}
                onClose={() => setIsDialogOpen(false)}
            />}
        </div>
    )
}
